import React, { useEffect, useState } from 'react';
import { useStore } from '@thd-nucleus/experience-context';
import { QueryProvider, useDataModel, useLazyDataModel } from '@thd-nucleus/data-sources';
import { string, bool, number } from 'prop-types';
import { Col, Row } from '@thd-olt-component-react/core-ui';
import className from 'classnames';
import { dynamicRecsDataModel } from '../dataModel';
import { RecommendationsProductPodCarousel } from '../core/RecommendationsProductPodCarousel';
import { isSearchLoading } from '../utils/helpers';

const SearchViewedRecs = ({
  anchorId,
  anchorImage,
  maxItems,
  showLoading,
  hideFavorites,
  itemIds
}) => {
  const { storeId, storeZip: zipCode, isLocalized } = useStore();
  const [data, setData] = useState(null);
  const [searchSchema, setSearchSchema] = useState(null);
  const schemaName = 'searchViewed';
  const multiSchemaName = 'plpsearch_multi';

  const searchOpts = {
    variables: {
      anchorId,
      apiName: schemaName,
      dataSource: schemaName,
      storeId,
      zipCode,
      skipSpecificationGroup: true,
      skipKPF: true,
      skipInstallServices: true,
      skipSubscribeAndSave: true,
      serviceType: null
    },
  };
  const { data: searchData, loading, error } = useDataModel('recs', searchOpts);

  const { recs } = searchData || {};
  const multiOpts = {
    manual: true,
    variables: {
      anchorId: itemIds,
      apiName: multiSchemaName,
      dataSource: multiSchemaName,
      serviceType: 'mutlianchor',
      storeId,
      zipCode,
      skipSpecificationGroup: true,
      skipSubscribeAndSave: true,
      skipKPF: true,
      skipInstallServices: true,
    },
  };

  const [
    getMultiProductSkus,
    {
      data: multiData,
      loading: multiLoading,
      error: multiError,
    }
  ] = useLazyDataModel('recs', multiOpts);

  const shouldRequestFallback = () => {
    return !loading && (searchData || error) && !multiLoading && !multiError && !multiData && !data;
  };

  useEffect(() => {
    if (searchData?.recs?.products?.length > 0) {
      setData(searchData);
      setSearchSchema(recs?.metadata?.apiName);
    } else if (shouldRequestFallback()) {
      getMultiProductSkus();
    }
  }, [searchData]);

  useEffect(() => {
    if (!data && multiData?.recs?.products?.length > 0) {
      setData(multiData);
      setSearchSchema(multiData?.recs?.metadata?.apiName);
    }
  }, [multiData]);

  const wrapperClasses = className(
    'dynamic-recs',
    searchSchema,
    {
      loading: showLoading && loading,
    }
  );

  if (multiError || (!loading && !multiLoading && !data
    && multiData !== undefined && !searchData?.recs && !multiData?.recs)) {
    return null;
  }

  return (
    <Row>
      <Col id={searchSchema} className={wrapperClasses} data-type="container">
        <meta data-prop="name" content={searchSchema} />
        <RecommendationsProductPodCarousel
          anchorImage={anchorImage}
          loading={isSearchLoading(data, searchData, multiData, loading, multiLoading)}
          hideFavorites={hideFavorites}
          itemClass="fixed-item"
          scheme={searchSchema}
          storeId={storeId}
          zipCode={zipCode}
          maxItems={maxItems}
          showLoading={showLoading}
          data={data?.recs}
        />
      </Col>
    </Row>
  );
};

SearchViewedRecs.dataModel = dynamicRecsDataModel;

SearchViewedRecs.displayName = 'SearchViewedRecs';

SearchViewedRecs.propTypes = {
  anchorId: string.isRequired,
  anchorImage: string,
  hideFavorites: bool,
  maxItems: number,
  showLoading: bool,
  itemIds: string,
};

SearchViewedRecs.defaultProps = {
  anchorImage: null,
  hideFavorites: true,
  showLoading: true,
  maxItems: 16,
  itemIds: ''
};

export default SearchViewedRecs;
